import { render, staticRenderFns } from "./Provincias.vue?vue&type=template&id=2a479f88"
import script from "./Provincias.vue?vue&type=script&lang=js"
export * from "./Provincias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports